import { HttpRequest } from '@angular/common/http';

/**
 * Checks if the request should bypass interceptor logic
 * @param request - The HTTP request
 * @returns true if the request should bypass interceptor processing
 */
export function shouldBypassInterceptor(request: HttpRequest<any>): boolean {
  return (
    request.url.includes('i18n/') ||
    request.url.includes('/assets/') ||
    request.url.includes('ipapi.co') ||
    request.url.includes('/azure-storage') ||
    request.url.includes('saeasybankshareprod')
  );
}

/**
 * Checks if the request is a login-related request
 * @param request - The HTTP request
 * @returns true if it's a login request
 */
export function isLoginRequest(request: HttpRequest<any>): boolean {
  return request.url.includes('login');
}
